export default __webpack_public_path__ + "static/media/twitter.6f865a4c.webp";